import React from 'react';
import { ActionPlanItemContextType } from '../../../../../services/types/ActionPlan';

const Context = React.createContext<ActionPlanItemContextType>({
  operationActionPlanItems: [],
  operationActionPlanDocuments: [],
  operationActionPlanExternalLinks: [],
  loading: true,
  reload: () => {},
});

export default Context;
